module.exports = __webpack_public_path__ + "img/filetype_img.357aea32.png";